/* Operator Coffee analytics: GA4 + GTM-compatible event helpers. */
(() => {
  'use strict';

  const dataLayer = window.dataLayer = window.dataLayer || [];

  function pushEvent(name, params = {}) {
    const payload = { ...params };
    dataLayer.push({ event: name, ...payload });
    if (typeof window.gtag === 'function') window.gtag('event', name, payload);
  }

  function textOf(element) {
    return element?.textContent?.trim().replace(/\s+/g, ' ') || '';
  }

  function bindShopNowLinks(root = document) {
    const selector = [
      'section[class*="banner"] a[href*="/collections"]',
      '.banner a[href*="/collections"]',
      '.image-banner a[href*="/collections"]',
      '.oc2-hero a[href*="/collections"]'
    ].join(',');
    root.querySelectorAll(selector).forEach((link) => {
      if (link.dataset.ocAnalyticsBound === 'shop-now') return;
      link.dataset.ocAnalyticsBound = 'shop-now';
      link.addEventListener('click', () => pushEvent('shop_now_click', {
        link_url: link.href,
        link_text: textOf(link)
      }));
    });
  }

  function subscriptionControls(root = document) {
    return root.querySelectorAll(
      '.rc-widget input[type="radio"], .rc-widget input[name*="selling_plan"], input[name="selling_plan"], input[name*="selling_plan"]'
    );
  }

  function bindSubscriptionControls(root = document) {
    subscriptionControls(root).forEach((input) => {
      if (input.dataset.ocAnalyticsBound === 'subscribe-toggle') return;
      input.dataset.ocAnalyticsBound = 'subscribe-toggle';
      input.addEventListener('change', () => {
        if (!input.checked) return;
        const form = input.form || input.closest('form');
        const inputValue = String(input.value || '').toLowerCase();
        const oneTime = ['', '0', 'once', 'one-time', 'one_time'].includes(inputValue);
        pushEvent('subscribe_toggle', {
          subscribed: !oneTime,
          selling_plan: input.value || undefined,
          variant_id: form?.querySelector('[name="id"]')?.value || undefined,
          control: input.closest('.rc-widget') ? 'recharge' : 'selling_plan'
        });
      });
    });
  }

  function productContext() {
    const info = document.querySelector('product-info[data-product-id]');
    const productComponent = document.querySelector('product-component[view-event-payload]');
    let standardData = {};
    try {
      standardData = JSON.parse(productComponent?.getAttribute('view-event-payload') || '{}');
    } catch (_) { /* Attribute is optional; fall back to DOM context. */ }
    const product = standardData.product || standardData;
    const id = info?.dataset.productId || product.id;
    const title = product.title || textOf(document.querySelector('.product__title h1, .product__title'));
    return { id: id ? String(id) : undefined, title };
  }

  function pushViewItem() {
    if (!document.querySelector('main[data-template="product"], product-info[data-product-id]')) return;
    const context = productContext();
    if (!context.id || window.__ocViewItemSent) return;
    window.__ocViewItemSent = true;
    pushEvent('view_item', {
      currency: window.Shopify?.currency?.active || 'USD',
      items: [{ item_id: context.id, item_name: context.title }]
    });
  }

  function cartAddDetails(input, init) {
    const body = init?.body;
    let variantId;
    let quantity = 1;
    if (body instanceof FormData) {
      variantId = body.get('id');
      quantity = parseInt(body.get('quantity'), 10) || 1;
    } else if (body instanceof URLSearchParams) {
      variantId = body.get('id');
      quantity = parseInt(body.get('quantity'), 10) || 1;
    } else if (typeof body === 'string') {
      const params = new URLSearchParams(body);
      variantId = params.get('id');
      quantity = parseInt(params.get('quantity'), 10) || 1;
    }
    return { variant_id: variantId || undefined, quantity };
  }

  function instrumentCartAdd() {
    if (typeof window.fetch !== 'function' || window.__ocCartFetchInstrumented) return;
    window.__ocCartFetchInstrumented = true;
    const originalFetch = window.fetch;
    window.fetch = function ocAnalyticsFetch(input, init) {
      const url = typeof input === 'string' ? input : input?.url || '';
      const isCartAdd = /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(url);
      const details = isCartAdd ? cartAddDetails(input, init) : null;
      return originalFetch.apply(this, arguments).then((response) => {
        if (isCartAdd && response.ok) {
          pushEvent('add_to_cart', {
            currency: window.Shopify?.currency?.active || 'USD',
            items: [{ item_id: details.variant_id, quantity: details.quantity }],
            variant_id: details.variant_id,
            quantity: details.quantity
          });
        }
        return response;
      });
    };
  }

  function start() {
    bindShopNowLinks();
    bindSubscriptionControls();
    pushViewItem();
    instrumentCartAdd();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        bindShopNowLinks(node);
        bindSubscriptionControls(node);
      }));
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('cart-add', (event) => {
      const detail = event.detail || {};
      pushEvent('add_to_cart', {
        currency: window.Shopify?.currency?.active || 'USD',
        ...detail
      });
    });
  }

  window.ocAnalytics = { pushEvent };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
